import { Notificacao } from "./notificacao.model"

export enum NotificacaoOperacao {
    ADICIONAR,
    REMOVER,
    LIMPAR
}

export class NotificacaoDTO {

  operacao: NotificacaoOperacao;
  notificacao: Notificacao;

}